import { render, staticRenderFns } from "./XunjiaDetail.vue?vue&type=template&id=5aa3b923&scoped=true"
import script from "./XunjiaDetail.vue?vue&type=script&lang=js"
export * from "./XunjiaDetail.vue?vue&type=script&lang=js"
import style0 from "./XunjiaDetail.vue?vue&type=style&index=0&id=5aa3b923&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa3b923",
  null
  
)

export default component.exports